import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { FormRenderComponent } from '../../widgets/form-render/form-render.component';
import { FormsServiceService } from '../../../api/services/forms-service.service';
import { WorkflowService } from '../../../api/services/workflow.service';
import { SseService } from '../../../api/services/sse.service';
import { CommonModule } from '@angular/common';
import { ModalRendererComponent } from '../../widgets/modal-renderer/modal-renderer.component';

@Component({
  selector: 'app-integration-list',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ModalRendererComponent,
  ],
  templateUrl: './integration-list.component.html',
  styleUrl: './integration-list.component.css',
})
export class IntegrationListComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Output() loadingChange = new EventEmitter<boolean>();
  @Input() selectedCategory: any;
  showValidationError = false;
  fieldsData: any;
  endpoint = environment.api_endpoint;
  selectedOptions: any[] = [];
  loadingCards: Set<string> = new Set();
  modalTitle: string = '';
  activeModalContext: any;
  workflowData: any;
  currentRecordId: string | undefined;
  currentNodeId: any;
  currentNode: any;
  recordID: any;
  nextNodes: any;
  targetWorkflowId: any;
  targetValue: any;
  workflowId: any;
  accessToken: any;
  previousNodeId: any;
  intervalId: any;
  isLoading: boolean = false;
  @ViewChild(FormRenderComponent) FormRenderComponent!: FormRenderComponent;
  @ViewChild(ModalRendererComponent) modalRendererRef!: ModalRendererComponent;

  constructor(
    private formService: FormsServiceService,
    private workflowService: WorkflowService,
    private SseService: SseService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.getData();
  }

  ngOnDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes['formGroup'] || changes['fields']) &&
      this.formGroup &&
      this.fields
    ) {
      this.getData();
    }
  }

  get control() {
    return this.formGroup.get(this.fields.fieldName);
  }

  getData() {
    this.isLoading = true;
    this.loadingChange.emit(true);
    if (this.fields && this.fields.options.isStatic == true) {
      this.fieldsData = this.fields?.options?.staticOptions;
      if (this.fields?.value?.length && this.fieldsData) {
        const selectedIds = this.fields.value.map((v: any) => v.toString());
        const validSelections = this.fieldsData
          .map((item: any) => item._id.toString())
          .filter((id: string) => selectedIds.includes(id));
        this.control?.setValue(validSelections, { emitEvent: false });
      }
      this.restoreTagsFromSelectedOptions();
      this.isLoading = false;
      this.loadingChange.emit(false);
    } else if (this.fields && this.fields.options.isStatic == false) {
      this.isLoading = true;
      const formId = this.fields.options.source.formID;
      const api_endpoint = this.endpoint;
      const method = this.fields.options.source.method;
      let url = this.fields.options.source.apiUrl;
      const replacements = { formID: formId, api_endpoint: api_endpoint };
      url = this.formService.replaceTemplateTokens(url, replacements);
      const accessToken = localStorage.getItem('accessToken');
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      };
      this.formService.loadData(method, url, headers).subscribe({
        next: (res) => {
          this.fieldsData = res.data.records;
          this.restoreTagsFromSelectedOptions();
          this.isLoading = false;
          this.loadingChange.emit(false);
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.loadingChange.emit(false);
          this.cdr.detectChanges();
        },
      });
    }
  }

  restoreTagsFromSelectedOptions() {
    if (!this.fieldsData?.length) return;
    const currentValue = (this.fields?.value || []).map((v: any) =>
      v.toString(),
    );
    const selectedOptions = this.fieldsData.filter((opt: any) =>
      currentValue.includes(opt._id?.toString()),
    );
    const restoredIds = selectedOptions.map((opt: any) => opt._id.toString());
    if (JSON.stringify(currentValue) !== JSON.stringify(restoredIds)) {
      this.control?.setValue(restoredIds, { emitEvent: false });
    }
    const selectedNames = selectedOptions.map((opt: any) => opt.name);
    this.formGroup
      .get(this.fields.fieldName + 'Tags')
      ?.setValue(selectedNames, { emitEvent: false });
  }

  isSelected(option: any): boolean {
    return option.status == 'Connected';
  }

  isDisabled(option: any): boolean {
    if (this.fields?.fieldType !== 'singleSelect') return false;
    const value = (this.control?.value || this.fields?.value || []).map(
      (v: any) => v.toString(),
    );
    return value.length > 0 && !value.includes(option._id?.toString());
  }

  toggleSelection(option: any, type: any): void {
    const optionId = option._id?.toString();
    const optionName = option.platformName;
    const tagsControl = this.formGroup.get(this.fields.fieldName + 'Tags');
    const isAlreadySelected = option.status == 'Connected';

    if (this.fields?.fieldType === 'singleSelect') {
      if (isAlreadySelected && type === 'disconnect') {
        const fieldDeps = option?.fieldDependencies || [];
        const onClickDep = fieldDeps.find(
          (dep: any) => dep.trigger === 'onClick',
        );
        const disconnectBlock = onClickDep?.condition?.find(
          (block: any) => block.action === 'disconnect',
        );
        const modalCond = disconnectBlock?.conditions?.find(
          (c: any) =>
            c.type === 'modal' && c.targetType === 'form' && c.targetValue,
        );
        if (modalCond) {
          this.activeModalContext = {
            workflowId: null,
            nodeId: modalCond.targetValue,
            selectedOption: option,
            selectedName: option.platformName,
            fieldName: this.fields.fieldName,
            fieldID: optionId,
          };
          this.loadNode(modalCond.targetValue);
          document
            .getElementById(`connection_modal_${this.fields.fieldName}`)
            ?.classList.add('show');
          this.loadingCards.delete(optionId);
          return;
        }
        this.control?.setValue([]);
        tagsControl?.setValue([]);
        this.selectedOptions = [];
        this.loadingCards.delete(optionId);
        return;
      }

      if (type === 'connect') {
        this.loadingCards.add(optionId);
        const fieldDeps = option?.fieldDependencies || [];
        const onClickDep = fieldDeps.find(
          (dep: any) => dep.trigger === 'onClick',
        );
        const connectBlock = onClickDep?.condition?.find(
          (block: any) => block.action === 'connect',
        );
        const modalCond = connectBlock?.conditions?.find(
          (c: any) =>
            c.type === 'modal' &&
            ['workflow', 'form'].includes(c.targetType) &&
            c.targetValue,
        );
        if (modalCond) {
          this.activeModalContext = {
            workflowId:
              modalCond.targetType === 'workflow'
                ? modalCond.targetValue
                : null,
            formId:
              modalCond.targetType === 'form' ? modalCond.targetValue : null,
            selectedOption: option,
            authUrl: option.integration?.authUrl,
            selectedName: option.platformName,
            fieldName: this.fields.fieldName,
            fieldID: optionId,
          };
          if (modalCond.targetType === 'workflow')
            this.loadWorkflow(modalCond.targetValue, 0);
          if (modalCond.targetType === 'form')
            this.loadNode(modalCond.targetValue);
          document
            .getElementById(`connection_modal_${this.fields.fieldName}`)
            ?.classList.add('show');
          this.loadingCards.delete(optionId);
          return;
        }
        if (option.integration?.authUrl) {
          let authUrl = option.integration.authUrl.replace(
            '{{base}}',
            this.endpoint,
          );
          this.accessToken = localStorage.getItem('accessToken') || '';
          const sep = authUrl.includes('?') ? '&' : '?';
          authUrl += `${sep}at=${encodeURIComponent(this.accessToken)}`;
          window.open(authUrl, '_blank');
        } else if (
          option.integration?.allowIntegration &&
          option.integration?.url
        ) {
          window.open(option.integration.url, '_blank');
        }
        const sub = this.SseService.getMessages().subscribe((msg: any) => {
          try {
            const parsed = typeof msg === 'string' ? JSON.parse(msg) : msg;
            if (
              parsed?.type === 'connectionSuccess' ||
              parsed?.type === 'connectSuccess' ||
              parsed?.payload?.status === 200
            ) {
              this.control?.setValue([optionId]);
              tagsControl?.setValue([optionName]);
              this.selectedOptions = [optionId];
              this.control?.markAsTouched();
              this.control?.updateValueAndValidity();
              this.showValidationError = false;
              this.loadingCards.delete(optionId);
              sub.unsubscribe();
            }
          } catch (err) {
            console.error('SSE parse error:', err);
          }
          this.cdr.detectChanges();
        });
      }
    }
  }

  loadWorkflow(wId: string, nodeId?: any, nodeIndex?: any): void {
    this.workflowData = null;
    this.workflowService.loadWorkflow(wId).subscribe({
      next: ({ workflowData, recordId }) => {
        this.workflowData = workflowData;
        this.currentRecordId = recordId;
        this.workflowId = wId;
        this.cdr.markForCheck();
        if (nodeIndex === 'secondLastNode') {
          const nodes = workflowData?.nodes || [];
          if (nodes.length >= 2) {
            const n = nodes[nodes.length - 2];
            this.currentNodeId = n._id;
            this.loadNode(n._id, recordId);
            return;
          }
        }
        const startNodeId = workflowData?.startNodeId;
        if (startNodeId) {
          this.currentNodeId = startNodeId;
          this.loadNode(startNodeId, recordId);
        }
        this.cdr.detectChanges();
      },
      error: (err: any) => {
        this.cdr.detectChanges();
      },
    });
  }

  loadNode(nodeId: any, recordId?: string): void {
    if (this.activeModalContext?.nodeId === nodeId) {
      this.currentNodeId = nodeId;
      this.currentNode = null;
      this.nextNodes = null;
      this.targetWorkflowId = null;
      return;
    }
    const node = this.workflowData?.nodes?.find((n: any) => n._id === nodeId);
    if (!node) return;
    this.currentNode = node;
    this.currentNodeId = node._id;
    this.recordID = node.recordId || recordId;
    this.loadPreviousNode();
    const idx = this.workflowData?.nodes?.findIndex(
      (n: any) => n._id === this.currentNode?._id,
    );
    const lastIdx = this.workflowData?.nodes?.length - 1;
    if (this.activeModalContext)
      this.activeModalContext.lastNode = idx === lastIdx;
    const nextBtn =
      node.next?.find((n: any) =>
        ['next_button', 'submit_continue'].includes(n.buttonId),
      ) || node.next?.[0];
    if (!nextBtn) return;
    const cond = nextBtn.condition;
    if (Array.isArray(cond)) {
      for (const c of cond) {
        if (c?.targetType === 'node' && c?.targetValue) {
          this.nextNodes = c.targetValue;
          return;
        }
        if (c?.targetNodeId) {
          this.nextNodes = c.targetNodeId;
          return;
        }
        if (c?.targetType === 'url' && c?.targetValue) {
          this.targetValue = c.targetValue;
          return;
        }
        if (c?.targetType === 'workflow' && c?.targetValue) {
          this.targetWorkflowId = c.targetValue;
          return;
        }
      }
    }
  }

  validateSelection(): boolean {
    const val = (this.control?.value || []).map((v: any) => v.toString());
    if (val.length > 0) {
      this.showValidationError = false;
      return true;
    }
    if (this.fields.isRequired) {
      this.showValidationError = true;
      return false;
    }
    this.showValidationError = false;
    return true;
  }

  closeOnBackdropClick(event: MouseEvent, modalId: string) {
    if (event.target === document.getElementById(modalId))
      this.closeModal(modalId);
  }

  closeModal(modalId: string) {
    document.getElementById(modalId)?.classList.remove('show');
    this.activeModalContext = null;
    if (this.modalRendererRef) this.modalRendererRef.stopChildPolling();
  }

  onModalFormSaved(event: any): void {
    const optionId = this.activeModalContext?.selectedOption?._id;
    const tagsControl = this.formGroup.get(this.fields.fieldName + 'Tags');
    if (!event?.success) return;
    const { nextNodeId, targetValue, targetWorkflowId, isSseTrigger } =
      this.resolveNavigationTargets(this.currentNode);
    const currentIdx = this.workflowData?.nodes?.findIndex(
      (n: any) => n._id === this.currentNode?._id,
    );
    const nextNodeIdx = this.workflowData?.nodes?.findIndex(
      (n: any) => n._id == nextNodeId,
    );
    const lastIdx = this.workflowData?.nodes?.length - 1;
    const isLast = currentIdx === lastIdx;
    const nextIsLast = nextNodeIdx === lastIdx;
    const firstId = this.workflowData?.nodes?.[0]?._id;
    const option = this.activeModalContext?.selectedOption;
    if (
      this.currentNode?._id === firstId &&
      option?.integration?.authUrl &&
      this.activeModalContext.selectedName !== 'Jira'
    ) {
      let authUrl = option.integration.authUrl.replace(
        '{{base}}',
        this.endpoint,
      );
      this.accessToken = localStorage.getItem('accessToken') || '';
      const sep = authUrl.includes('?') ? '&' : '?';
      authUrl += `${sep}at=${encodeURIComponent(this.accessToken)}`;
      window.open(authUrl, '_blank');
    }
    const setConnected = () => {
      const nv = [this.activeModalContext?.selectedOption?._id];
      const nt = [this.activeModalContext?.selectedOption?.name];
      this.control?.setValue(nv);
      tagsControl?.setValue(nt);
      this.selectedOptions = [...nv];
      this.control?.markAsTouched();
      this.control?.updateValueAndValidity();
      this.loadingCards.delete(optionId);
    };
    if (nextIsLast && !isLast) {
      setConnected();
      this.currentNode.selectedOptions = this.selectedOptions;
      this.workflowData.selectedOptions = this.selectedOptions;
    }
    if (isLast) {
      setConnected();
      this.currentNode.selectedOptions = this.selectedOptions;
      this.workflowData.selectedOptions = this.selectedOptions;
    }
    if (nextNodeId && !isSseTrigger) {
      this.loadNode(nextNodeId);
      return;
    }
    if (targetValue) {
      const t = localStorage.getItem('accessToken');
      if (t) {
        window.location.href = `${targetValue}/${t}`;
        return;
      }
    }
    if (targetWorkflowId) {
      this.loadWorkflow(targetWorkflowId);
      return;
    }
    const modalId = `connection_modal_${this.fields.fieldName}`;
    document.getElementById(modalId)?.classList.remove('show');
    this.activeModalContext = null;
  }

  resolveNavigationTargets(node: any): any {
    const fb = {
      nextNodeId: null,
      targetValue: null,
      targetWorkflowId: null,
      recordId: node?.recordId ?? null,
      isSseTrigger: false,
    };
    if (!node?.next || !Array.isArray(node.next)) return fb;
    const nb =
      node.next.find((n: any) =>
        ['next_button', 'submit_continue'].includes(n.buttonId),
      ) || node.next[0];
    if (!nb) return fb;
    const cond = nb.condition;
    if (Array.isArray(cond)) {
      for (const c of cond) {
        if (c?.targetType === 'node' && c?.targetValue)
          return { ...fb, nextNodeId: c.targetValue };
        if (c?.targetNodeId) return { ...fb, nextNodeId: c.targetNodeId };
        if (c?.targetType === 'url' && c?.targetValue)
          return { ...fb, targetValue: c.targetValue };
        if (c?.targetType === 'workflow' && c?.targetValue)
          return { ...fb, targetWorkflowId: c.targetValue };
      }
    }
    return fb;
  }

  setModalTitle(title: string) {
    this.modalTitle = title;
  }

  loadPreviousNode(): void {
    const prev = this.currentNode?.previous?.find(
      (p: any) => p.buttonId === 'previous_button',
    );
    if (prev?.targetNodeId) this.previousNodeId = prev.targetNodeId;
  }

  clickedOnPrevious() {
    const node = this.workflowData.nodes.find(
      (n: any) => n._id === this.currentNodeId,
    );
    if (node?.previous?.length > 0) {
      const { targetNodeId } = node.previous[0];
      if (targetNodeId) {
        this.workflowData.currentNodeId = targetNodeId;
        this.loadNode(targetNodeId);
      }
    }
  }

  checkPollingServiceForError(value: any) {
    const attemptNode = this.currentNode?.next?.find((next: any) =>
      next.condition.some((cg: any) =>
        cg.conditions.some((c: any) => c.type === 'attempts'),
      ),
    );
    if (attemptNode) {
      const tId = attemptNode?.condition?.[0]?.targetValue;
      const tType = attemptNode?.condition?.[0]?.targetType;
      if (tType === 'node' && tId) this.loadNode(tId);
      else if (tType === 'workflow' && tId) this.loadWorkflow(tId);
    }
  }

  trackById(index: number, item: any) {
    return item._id;
  }
  reloadData() {
    this.getData();
  }

  @HostListener('document:keydown.escape')
  onEscapeKey() {
    if (this.fields?.fieldName)
      this.closeModal('connection_modal_' + this.fields.fieldName);
  }
}
